import React from 'react';
import { ExternalLink } from 'lucide-react';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

export const GrasrotandelenBanner = () => {
  useTranslation();
  return (
    <section 
      data-testid="grasrotandelen-banner"
      className="py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-slate-800 via-slate-800 to-slate-800"
    >
      <div className="max-w-5xl mx-auto">
        <div className="bg-slate-700/50 rounded-2xl border border-slate-600 overflow-hidden">
          <div className="p-6 sm:p-8 lg:p-10">
            {/* Logos */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 mb-8">
              <img 
                src="https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/isw6v7hg_VSK%20logo.png"
                alt={t('pg.GrasrotandelenBanner.ade82c')}
                className="h-20 sm:h-24 object-contain"
              />
              <div className="hidden sm:block text-4xl text-slate-500">+</div>
              <img 
                src="https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/bdtmj4sc_Norsk%20Tipping.png"
                alt={t('pg.GrasrotandelenBanner.58622f')}
                className="h-12 sm:h-16 object-contain"
              />
            </div>
            
            {/* Title */}
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-white mb-4">
              {t('pg.GrasrotandelenBanner.33fdbe')}
            </h2>
            
            {/* Description */}
            <p className="text-center text-slate-300 text-base sm:text-lg max-w-2xl mx-auto mb-6">
              {t('pg.GrasrotandelenBanner.15cb59')}
            </p>
            
            {/* SMS Info Box */}
            <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-4 sm:p-6 max-w-lg mx-auto mb-8">
              <p className="text-center">
                <span className="text-slate-400 text-sm sm:text-base">{t('pg.GrasrotandelenBanner.13b9b8')}</span>
                <br />
                <span className="text-green-400 font-bold text-lg sm:text-xl">{t('pg.GrasrotandelenBanner.6e9c02')}</span>
                <br />
                <span className="text-slate-400 text-sm sm:text-base">{t('pg.GrasrotandelenBanner.79bb15')}</span>
                <span className="text-white font-bold text-lg sm:text-xl ml-2">60000</span>
              </p>
            </div>
            
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="https://www.norsk-tipping.no/grasrotandelen/soek?LagID=971528117"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-500 text-white font-bold px-6 py-3 rounded-lg hover:bg-green-600 transition-colors"
                data-testid="grasrot-support-btn"
              >
                {t('pg.GrasrotandelenBanner.412a9c')}
                <ExternalLink className="w-4 h-4" />
              </a>
              <a 
                href="https://www.norsk-tipping.no/grasrotandelen"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-slate-500 text-white font-medium px-6 py-3 rounded-lg hover:bg-slate-600 transition-colors"
                data-testid="grasrot-learn-more-btn"
              >
                {t('pg.GrasrotandelenBanner.864401')}
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrasrotandelenBanner;
